import React from "react";
import { LANDING } from "@/constants/testIds";

const CATEGORIES = [
  "Retail shops",
  "Supermarkets",
  "Pharmacies",
  "Provision stores",
  "Boutiques",
  "Spare parts",
  "Mini-marts",
  "Wholesalers",
  "Distributors",
  "Cosmetic shops",
];

export const TrustedBy = () => {
  return (
    <section
      data-testid={LANDING.trustedBy}
      aria-label="Built for many kinds of retail business"
      className="border-y border-[#0E6B6B]/10 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12 py-10">
        <p className="text-center text-xs sm:text-sm tracking-[0.2em] uppercase font-bold text-[#0E6B6B]">
          Built for independent retailers and the operations growing around them
        </p>
        <div className="relative mt-6 overflow-hidden">
          <div className="absolute left-0 top-0 h-full w-16 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 h-full w-16 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
          <div className="flex w-max gap-12 animate-marquee">
            {[...CATEGORIES, ...CATEGORIES].map((c, i) => (
              <div
                key={i}
                className="font-display text-lg sm:text-xl text-[#2c4040]/70 whitespace-nowrap"
              >
                {c}
                <span className="ml-12 text-[#D96C4A]/60">✦</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
